export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [

];
